import _ from 'lodash';
import { IAffinityCluster, IObservation } from 'src/Definitions';

export default class AffinityClusterDialogLogic {
    public undo(affinityCluster: IAffinityCluster, observation: IObservation) {
        _.remove(affinityCluster!.observations!, (x) => x.id === observation.id);
        return affinityCluster;
    }
}



// WEBPACK FOOTER //
// ./src/affinityClusters/AffinityClusterDialogLogic.tsx